module.exports = __webpack_public_path__ + "img/avatar_bg.2020fa4.png";